// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as BrochureCompletRouteImport } from './routes/brochure-complet'
import { Route as HeroARouteImport } from './routes/hero-a'
import { Route as HeroBRouteImport } from './routes/hero-b'
import { Route as HeroCRouteImport } from './routes/hero-c'
import { Route as AdminIndexRouteImport } from './routes/admin/index'
import { Route as AdminDegreesRouteImport } from './routes/admin/degrees'
import { Route as AdminFichesRouteImport } from './routes/admin/fiches'
import { Route as AdminLeadsRouteImport } from './routes/admin/leads'
import { Route as AdminLoginRouteImport } from './routes/admin/login'
import { Route as AdminQuestionnairesRouteImport } from './routes/admin/questionnaires'
import { Route as AdminRegisterLeadRouteImport } from './routes/admin/register-lead'
import { Route as AdminSchedulingRouteImport } from './routes/admin/scheduling'
import { Route as AdminTrainingsRouteImport } from './routes/admin/trainings'
import { Route as AdminUsersRouteImport } from './routes/admin/users'
import { Route as AdminWeeklyReportRouteImport } from './routes/admin/weekly-report'
import { Route as BrochureSlugRouteImport } from './routes/brochure/$slug'
import { Route as FeedbackSlugRouteImport } from './routes/feedback/$slug'
import { Route as TrainingSlugRouteImport } from './routes/training/$slug'
import { Route as AdminEditionsEditionIdRouteImport } from './routes/admin/editions.$editionId'
import { Route as AdminMarketingReportEditionIdRouteImport } from './routes/admin/marketing-report.$editionId'
import { Route as AdminTrainingsTrainingIdRouteImport } from './routes/admin/trainings_.$trainingId'
import { Route as FeedbackSlugEditionRouteImport } from './routes/feedback/$slug_.$edition'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AdminRoute = AdminRouteImport.update({
            id: '/admin',path: '/admin',getParentRoute: () => rootRouteImport
          })
const BrochureCompletRoute = BrochureCompletRouteImport.update({
            id: '/brochure-complet',path: '/brochure-complet',getParentRoute: () => rootRouteImport
          })
const HeroARoute = HeroARouteImport.update({
            id: '/hero-a',path: '/hero-a',getParentRoute: () => rootRouteImport
          })
const HeroBRoute = HeroBRouteImport.update({
            id: '/hero-b',path: '/hero-b',getParentRoute: () => rootRouteImport
          })
const HeroCRoute = HeroCRouteImport.update({
            id: '/hero-c',path: '/hero-c',getParentRoute: () => rootRouteImport
          })
const AdminIndexRoute = AdminIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AdminRoute
          })
const AdminDegreesRoute = AdminDegreesRouteImport.update({
            id: '/degrees',path: '/degrees',getParentRoute: () => AdminRoute
          })
const AdminFichesRoute = AdminFichesRouteImport.update({
            id: '/fiches',path: '/fiches',getParentRoute: () => AdminRoute
          })
const AdminLeadsRoute = AdminLeadsRouteImport.update({
            id: '/leads',path: '/leads',getParentRoute: () => AdminRoute
          })
const AdminLoginRoute = AdminLoginRouteImport.update({
            id: '/login',path: '/login',getParentRoute: () => AdminRoute
          })
const AdminQuestionnairesRoute = AdminQuestionnairesRouteImport.update({
            id: '/questionnaires',path: '/questionnaires',getParentRoute: () => AdminRoute
          })
const AdminRegisterLeadRoute = AdminRegisterLeadRouteImport.update({
            id: '/register-lead',path: '/register-lead',getParentRoute: () => AdminRoute
          })
const AdminSchedulingRoute = AdminSchedulingRouteImport.update({
            id: '/scheduling',path: '/scheduling',getParentRoute: () => AdminRoute
          })
const AdminTrainingsRoute = AdminTrainingsRouteImport.update({
            id: '/trainings',path: '/trainings',getParentRoute: () => AdminRoute
          })
const AdminUsersRoute = AdminUsersRouteImport.update({
            id: '/users',path: '/users',getParentRoute: () => AdminRoute
          })
const AdminWeeklyReportRoute = AdminWeeklyReportRouteImport.update({
            id: '/weekly-report',path: '/weekly-report',getParentRoute: () => AdminRoute
          })
const BrochureSlugRoute = BrochureSlugRouteImport.update({
            id: '/brochure/$slug',path: '/brochure/$slug',getParentRoute: () => rootRouteImport
          })
const FeedbackSlugRoute = FeedbackSlugRouteImport.update({
            id: '/feedback/$slug',path: '/feedback/$slug',getParentRoute: () => rootRouteImport
          })
const TrainingSlugRoute = TrainingSlugRouteImport.update({
            id: '/training/$slug',path: '/training/$slug',getParentRoute: () => rootRouteImport
          })
const AdminEditionsEditionIdRoute = AdminEditionsEditionIdRouteImport.update({
            id: '/editions/$editionId',path: '/editions/$editionId',getParentRoute: () => AdminRoute
          })
const AdminMarketingReportEditionIdRoute = AdminMarketingReportEditionIdRouteImport.update({
            id: '/marketing-report/$editionId',path: '/marketing-report/$editionId',getParentRoute: () => AdminRoute
          })
const AdminTrainingsTrainingIdRoute = AdminTrainingsTrainingIdRouteImport.update({
            id: '/trainings_/$trainingId',path: '/trainings/$trainingId',getParentRoute: () => AdminRoute
          })
const FeedbackSlugEditionRoute = FeedbackSlugEditionRouteImport.update({
            id: '/feedback/$slug_/$edition',path: '/feedback/$slug/$edition',getParentRoute: () => rootRouteImport
          })





const AdminRouteChildren = {
  AdminDegreesRoute: AdminDegreesRoute,AdminFichesRoute: AdminFichesRoute,AdminLeadsRoute: AdminLeadsRoute,AdminLoginRoute: AdminLoginRoute,AdminQuestionnairesRoute: AdminQuestionnairesRoute,AdminRegisterLeadRoute: AdminRegisterLeadRoute,AdminSchedulingRoute: AdminSchedulingRoute,AdminTrainingsRoute: AdminTrainingsRoute,AdminUsersRoute: AdminUsersRoute,AdminWeeklyReportRoute: AdminWeeklyReportRoute,AdminIndexRoute: AdminIndexRoute,AdminEditionsEditionIdRoute: AdminEditionsEditionIdRoute,AdminMarketingReportEditionIdRoute: AdminMarketingReportEditionIdRoute,AdminTrainingsTrainingIdRoute: AdminTrainingsTrainingIdRoute
}

const AdminRouteWithChildren = AdminRoute._addFileChildren(AdminRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AdminRoute: AdminRouteWithChildren,BrochureCompletRoute: BrochureCompletRoute,HeroARoute: HeroARoute,HeroBRoute: HeroBRoute,HeroCRoute: HeroCRoute,BrochureSlugRoute: BrochureSlugRoute,FeedbackSlugRoute: FeedbackSlugRoute,TrainingSlugRoute: TrainingSlugRoute,FeedbackSlugEditionRoute: FeedbackSlugEditionRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)